// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__10F00","messages":"Chat_messages__1guc-","dateDivider":"Chat_dateDivider__1dGdc"};